// Scheme allowlist for URLs that come from query params or API data before
// they reach an href or window.open. A javascript: URL rendered as a link
// executes in this origin — with the session on this origin, that is a
// one-click account takeover. Returns the URL or null.
export function safeUrl(url) {
  if (typeof url !== 'string' || !url) return null;
  try {
    const parsed = new URL(url, window.location.origin);
    if (parsed.protocol === 'http:' || parsed.protocol === 'https:') return url;
  } catch (e) { /* unparseable */ }
  return null;
}

// Validate a ?next= destination before navigating to it after login. An
// open redirect here hands a phished user straight back to an attacker's
// page wearing our login flow, so only same-origin absolute paths pass:
//  - must start with a single "/" (no "http://evil", no "javascript:")
//  - "//evil.com" and "/\evil.com" are protocol-relative URLs in browsers
//  - "/login…" would loop the user back through the login page
export function safeNextPath(next, fallback = '/') {
  if (typeof next !== 'string' || !next) return fallback;
  if (next[0] !== '/') return fallback;
  if (next[1] === '/' || next[1] === '\\') return fallback;
  if (next === '/login' || next.startsWith('/login?') || next.startsWith('/login/') || next.startsWith('/login#')) {
    return fallback;
  }
  return next;
}
